import {
  NON_AUTH_ENDPOINT,
  NON_AUTH_PAGE,
} from '@jobseeker/common-core/constants';
import axios from 'axios';
//import {AxiosError} from 'axios';
import qs from 'qs';
import {clearAuth} from '@jobseeker/common-core/utils';
import {openUrl} from '@jobseeker/common-core/utils/common';
import {enqueueSnackbar} from 'notistack';

const reloadLocation = () => {
  let href = '/';
  const publicPath = ['/c/', '/k/', '/j/'];
  const pathName = window.location?.pathname || '/';
  for (const path of publicPath) {
    if (pathName.includes(path)) {
      href = window.location?.href;
    }
  }

  openUrl(href, '_self');
};

const handleRefresh = async (config: object) => {
  const AUTH_API_PATH: string =
    `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_AUTH}/refresh` ||
    '';

  const response = await axios.get(`${AUTH_API_PATH}`, config);
  return response?.['data']?.token;
};

const handleLogout = async (config: object) => {
  await axios.post(
    `${process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR}/${process.env.NEXT_PUBLIC_PREFIX_USER_SERVICE}/logout`,
    qs.stringify({}),
    config
  );
};

export const csrHandler = async (error: any /** AxiosError */) => {
  if (
    error?.response?.status === 401 &&
    !NON_AUTH_ENDPOINT.includes(error?.config?.url || '')
  ) {
    const pathSegment = window.location?.pathname?.split('/')[1];
    if (
      NON_AUTH_PAGE.includes(pathSegment) ||
      pathSegment?.includes('careers') || pathSegment?.includes('jobs-in')
    ) {
      return;
    }
    openUrl('/', '_self');
  }

  if (
    [406].includes(error?.response?.status || 0) &&
    !NON_AUTH_ENDPOINT.includes(error?.config?.url || '')
  ) {
    const config: {[key: string]: boolean | object | string} = {
      withCredentials: true,
    };

    try {
      await handleRefresh(config);
    } catch (error: any) {
      if (error?.response?.status === 406) {
        await handleLogout({
          withCredentials: true,
        });
        clearAuth();
        reloadLocation();
      }
    }

    const data = await axios(error.config);
    if (data?.status === 200) {
      return data;
    }
    return axios(error.config);
  }

  if (
    error?.response?.status === 418 &&
    !NON_AUTH_ENDPOINT.includes(error?.config?.url || '')
  ) {
    // status code 418 is fixed for intensional logout cases
    await handleLogout({
      withCredentials: true,
    });
    clearAuth();
    reloadLocation();
  } else {
    if (!navigator.onLine) {
      // Real offline status
      const message = 'Please check your internet connection and try again.';
      const response = {
        data: {
          error: {
            message,
            statusCode: 0,
          },
        },
      };
      error['response'] = response;

      enqueueSnackbar(message, {variant: 'error'});
      return Promise.reject(error);
    } else if (
      error?.code === 'ECONNABORTED' ||
      error?.message === 'Network Error'
    ) {
      let message = `Taking too long to respond. Please try again later.`;

      try {
        const basePath = error?.config?.baseURL?.split('/');
        const gladBasePath =
          process.env.NEXT_PUBLIC_API_GATEWAY_GLADIATOR?.split('/')[2];

        const vertical = (
          basePath[2] === gladBasePath
            ? basePath[3] === 'ext'
              ? basePath[4]
              : basePath[3]
            : basePath[2]
        )
          .slice(0, 2)
          .toUpperCase();

        message = `Taking too long to respond ${vertical}. Please try again later.`;
      } catch (error) {
        console.log('Error in extracting vertical name', error);
      }
      const response = {
        data: {
          error: {
            message,
            statusCode: 0,
          },
        },
      };
      error['response'] = response;

      enqueueSnackbar(message, {variant: 'error'});
      return Promise.reject(error);
    } else if (error?.response?.status === 502) {
      const response = {
        data: {
          error: {
            message: 'Something went wrong, please try again after some time!!',
            statusCode: 0,
          },
        },
      };
      error['response'] = response;
      enqueueSnackbar(
        'Something went wrong, please try again after some time!!',
        {
          variant: 'error',
        }
      );
    }

    return Promise.reject(error);
  }
};

export const ssrHandler = async (error: any /** AxiosError */) => {
  if (
    error?.response?.status === 401 &&
    !NON_AUTH_ENDPOINT.includes(error?.config?.url || '')
  ) {
    return {
      type: 'logout',
    };
  }
  if (
    [406].includes(error?.response?.status || 0) &&
    !NON_AUTH_ENDPOINT.includes(error?.config?.url || '')
  ) {
    try {
      const headers = {
        cookie: error.config?.headers?.cookie,
      };

      const token = await handleRefresh({headers});
      return token ? {type: 'refresh', token} : false;
    } catch (error: any) {
      if (error?.response?.status === 406) {
        const headers = {
          cookie: error.config?.headers?.cookie,
        };

        try {
          await handleLogout({headers});
          return {
            type: 'logout',
          };
        } catch (err) {
          return {
            type: 'logout',
          };
        }
      }
    }

    return axios(error.config);
  } else if (error?.response?.status === 418) {
    // status code 418 is fixed for intensional logout cases
    const headers = {
      cookie: error.config?.headers?.cookie,
    };

    try {
      await handleLogout({headers});
      return {
        type: 'logout',
      };
    } catch (err) {
      return {
        type: 'logout',
      };
    }
  } else {
    return Promise.reject(error);
  }
};
